module.exports = __webpack_public_path__ + "img/button-call.4b06111b.svg";